export enum PlayingStateEnum {
  Play = 'play',
  Pause = 'pause',
}
